import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Imgix from 'react-imgix';

import { ArticleOrBriefingDataContent } from '..';
import { article_path, briefing_path } from '../../../routes';
import { getArticleImgSrc } from '../../../utils/images';
import { MaybeLink } from '../../BaseUI';
import AuthorsLine from '../AuthorsLine';
import EntityTopics from '../EntityTopics';
import Highlight from '../Highlight';
import styles from './styles.module.scss';

// TODO: convert to camelCase
export type ArticleOrBriefing = {
  created_at: string;
  dek: string;
  guid: string;
  headline?: string;
  highlight: string;
  id: number;
  picture: string | null;
  publish_on_web: boolean;
  published_at?: string;
  slug: string;
  title?: string;
};

export default function ArticleOrBriefingFeedItem({
  articleOrBriefing,
  articleOrBriefingData,
  commentCount,
  useFeaturedLayout,
}: {
  articleOrBriefing: ArticleOrBriefing;
  articleOrBriefingData: ArticleOrBriefingDataContent;
  commentCount?: number;
  useFeaturedLayout?: boolean;
}) {
  const type = articleOrBriefingData.type;
  const articlePath = articleOrBriefing.publish_on_web
    ? article_path(articleOrBriefing.slug)
    : undefined;

  const href = type === 'Article' ? articlePath : briefing_path(articleOrBriefing.guid);
  const imgWidth = useFeaturedLayout ? 500 : 270;
  return (
    <div
      className={clsx(styles.feedItem, {
        [styles.featured]: useFeaturedLayout,
      })}
    >
      <div className={styles.content}>
        <div className={styles.details}>
          {!!articleOrBriefing.highlight && articleOrBriefingData.highlightSlug && (
            <Highlight
              name={articleOrBriefing.highlight}
              slug={articleOrBriefingData.highlightSlug}
            />
          )}
          {!!articleOrBriefingData.entityTopics && (
            <EntityTopics topics={articleOrBriefingData.entityTopics} />
          )}
        </div>
        <MaybeLink
          href={href}
          className="track-link"
          id={`article-${articleOrBriefing.id}`}
          data-type="link"
          data-name="article title"
          data-location="feed"
        >
          <div className={styles.title}>
            {articleOrBriefing.title || articleOrBriefing.headline}
          </div>
        </MaybeLink>
        <AuthorsLine
          authors={articleOrBriefingData.authors}
          date={articleOrBriefing.published_at || articleOrBriefing.created_at}
          commentCount={commentCount}
          slug={articleOrBriefing.slug}
        />
        <div className={styles.excerpt}>
          <MaybeLink href={href}>{ReactHtmlParser(articleOrBriefingData.excerpt)}</MaybeLink>
        </div>
      </div>
      <div className={styles.image}>
        <MaybeLink
          href={href}
          className="track-link"
          id={`article-${articleOrBriefing.id}`}
          data-type="link"
          data-name="article image"
          data-location="feed"
        >
          <Imgix
            src={getArticleImgSrc(articleOrBriefing.id, articleOrBriefing.picture)}
            width={imgWidth}
            height={(imgWidth * 9) / 16}
            imgixParams={{ fit: 'crop', 'gif-q': '50' }}
          />
        </MaybeLink>
      </div>
    </div>
  );
}
